import React from "react";
import { CinematicChaptersCoursePage } from "./CoursePageDesignsCore";
import MetaInfo from "./components/MetaInfo";
import Header from "./components/Header";
import Footer from "./components/Footer";

export default function CourseDetails3(props) {
    return (
        <>
            <MetaInfo />
            <Header school="common" />
            <CinematicChaptersCoursePage {...props} />;
            <Footer />
        </>
    )
};
